import styled from "styled-components";

import { SPACING, QUERIES } from "../../utils/constants";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100vw;
  background-color: var(--color-background-2);
  color: var(--color-text-default);

  /* Full screen on mobile devices */
  @media ${QUERIES.tabletAndDown} {
    width: 100vw;
    max-width: 100vw;
  }

  /* Fixed width on larger screens */
  @media ${QUERIES.laptopAndUp} {
    width: fit-content;
  }
`;

export const StyledTopBar = styled.div<{ $closeTrailing?: boolean }>`
  display: flex;
  height: auto;
  align-items: center;
  padding: ${SPACING.md}px;
  gap: ${SPACING.sm + SPACING.xs}px;
  background-color: var(--color-background-0);
  border-bottom: 1px solid var(--color-border);
  flex-direction: ${({ $closeTrailing }) =>
    $closeTrailing ? "row-reverse" : "row"};
  justify-content: ${({ $closeTrailing }) =>
    $closeTrailing ? "space-between" : "flex-start"};
`;

export const StyledFooter = styled.div`
  align-items: center;
  gap: ${SPACING.sm + SPACING.xs}px;
  padding: ${SPACING.md}px;
  background-color: var(--color-background-0);
  border-top: 1px solid var(--color-border);
`;

export const StyledContent = styled.div`
  overflow: auto;
  flex-grow: 1;
`;
